import { type FilteredView } from '../../../shared/types';
import { allDefaultCategoriesQueries } from '../../../shared/utils/filteredViews';

export const isFilteredViewPinnedOnSidebar = (view: FilteredView) => {
  return (
    !allDefaultCategoriesQueries.includes(view.query) && view.isUnpinned !== true && !view.rssFolderId
  );
};
